import styled from 'styled-components';
import Block from '@shared/components/ui/Block';
import { Text } from '@/components/Text';
import { ButtonLink } from '@/components/Button';

/**
 * Rendered by the catch-all (`path: '*'`) route for any URL that matches no
 * route. Mirrors the visual pattern of `RouteError` but communicates a 404
 * rather than an unexpected error.
 */
export function NotFoundPage() {
    return (
        <Block
            $verticalAlign="center"
            $align="center"
            style={{ height: '100vh' }}
        >
            <NotFoundWrapper>
                <Text
                    as="h1"
                    size="xxLarge"
                    weight="bold"
                    align="center"
                    spacing="xLarge"
                >
                    404 — Page not found
                </Text>
                <Text size="large" align="center" spacing="xLarge">
                    The page you're looking for doesn't exist or may have moved.
                </Text>
                <Block $align="center">
                    <ButtonLink
                        to="/"
                        $variant="secondary"
                        $borderColor="uNavy"
                        $color="uNavy"
                    >
                        Back to dashboard
                    </ButtonLink>
                </Block>
            </NotFoundWrapper>
        </Block>
    );
}

const NotFoundWrapper = styled.div`
    padding: 40px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.white};
    max-width: 570px;
`;
